import React, { useEffect, useState } from "react";
import api from "../setupAxios";
import { useDialog } from "../context/dialogContext";
import FiltrosAlumnos from "./FiltrosAlumnos";
import { descargar, useListado } from "../utils";

// Ensombrado: todos los alumnos en filas/columnas, con filtros, y PDF de etiquetas (masivo o uno a uno).
export default function PanelEnsombrado() {
  const { avisar } = useDialog();
  const [f, setF] = useState({});
  const [opciones, setOpciones] = useState({});
  const [bajando, setBajando] = useState("");
  const { datos, cargando, error } = useListado("/ensombrado/alumnos", f);

  useEffect(() => { api.get("/ensombrado/opciones").then(({ data }) => setOpciones(data)).catch(() => {}); }, []);

  const params = () => Object.fromEntries(Object.entries(f).filter(([, v]) => v !== "" && v != null));
  const pdfMasivo = async () => {
    setBajando("todos");
    const err = await descargar("/ensombrado/pdf", params(), "etiquetas_ensombrado.pdf");
    setBajando("");
    if (err) avisar(err);
  };
  const pdfUno = async (a) => {
    setBajando(String(a.id_user));
    const err = await descargar(`/ensombrado/pdf/${a.id_user}`, {}, `etiqueta_${a.id_cliente}.pdf`);
    setBajando("");
    if (err) avisar(err);
  };

  return (
    <div className="card">
      <div className="card-headrow">
        <h3>Ensombrado <span className="count">{datos.length}</span></h3>
      </div>
      <FiltrosAlumnos f={f} setF={setF} opciones={opciones} campos={["q", "piso", "servicio", "a_r"]}>
        <button className="btn btn-primary" onClick={pdfMasivo} disabled={bajando !== "" || datos.length === 0}>
          {bajando === "todos" ? "Generando…" : `📄 Descargar PDF (${datos.length} etiquetas)`}
        </button>
      </FiltrosAlumnos>
      {error && <div className="alert alert-error">{error}</div>}
      <div className="tablewrap">
        <table className="ci-tabla t-ensombrado">
          <thead><tr><th>ID Piso</th><th>ID cliente</th><th>Nombre</th><th>Piso</th><th>Habitación</th><th>SERV</th><th>Código</th><th>Admisiones/R</th><th /></tr></thead>
          <tbody>
            {cargando && datos.length === 0 && <tr><td colSpan={9} className="empty">Cargando…</td></tr>}
            {!cargando && datos.length === 0 && <tr><td colSpan={9} className="empty">No hay alumnos con esos filtros.</td></tr>}
            {datos.map((a, i) => (
              <tr key={`${a.id_user}-${i}`}>
                <td className="num-cell">{a.id_piso ?? "—"}</td>
                <td className="num-cell">{a.id_cliente}</td>
                <td className="ci-nombre">{a.nombre}</td>
                <td className="ci-wrap">{a.piso || "—"}</td>
                <td className="num-cell">{a.habitacion ?? "—"}</td>
                <td>{a.serv || "—"}</td>
                <td className="strong">{a.codigo || "—"}</td>
                <td>{a.adm_r || "—"}</td>
                <td><button className="btn btn-mini" disabled={bajando !== ""} onClick={() => pdfUno(a)} title="PDF de este alumno">📄</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
